import React from 'react';
import { Link } from 'react-router-dom';

export default function PageHeader({ titulo, subtitulo, acaoLabel, acaoTo, acaoIcon = 'bi-plus-lg', children }) {
  return (
    <div className="sf-card d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4 p-3 px-4">
      <div className="d-flex flex-column gap-1">
        <h1 style={{ margin: 0, fontSize: 23, fontWeight: 800, letterSpacing: '-0.025em' }}>{titulo}</h1>
        {subtitulo && <span style={{ fontSize: 13.5, color: 'var(--sf-text-muted)' }}>{subtitulo}</span>}
      </div>
      <div className="d-flex align-items-center gap-2">
        {children}
        {acaoLabel && acaoTo && (
          <Link to={acaoTo} className="sf-btn sf-btn-primary">
            <i className={`bi ${acaoIcon}`} />
            {acaoLabel}
          </Link>
        )}
      </div>
    </div>
  );
}
